import { render, staticRenderFns } from "./tt.vue?vue&type=template&id=61fd9c98&scoped=true"
import script from "./tt.vue?vue&type=script&lang=js"
export * from "./tt.vue?vue&type=script&lang=js"
import style0 from "./tt.vue?vue&type=style&index=0&id=61fd9c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fd9c98",
  null
  
)

export default component.exports